// extracted by mini-css-extract-plugin
export var header = "_43-0";